import { BaseApi, type RequestHeaders, type RequestParams, type ItemResponse } from '@bv/api/base';

export class WithShow<Item extends Record<string, any> = object> extends BaseApi {
  /**
   * Creates an instance of the child class.
   * This constructor passes the endpoint to the parent class's constructor.
   * @param {string} endpoint - The API endpoint that will be passed up to the base class constructor.
   */
  public constructor(endpoint: string) {
    super(endpoint);
  }

  /**
   * Retrieves a  single item by ID
   * @param {string|number} [id] - Item ID.
   * @param {Object} [config] - Configuration for the request.
   * @param {RequestParams} [config.params] - Additional query parameters to send with the request.
   * @param {RequestHeaders} [config.headers] - Custom HTTP headers to send with the request.
   * @returns {Promise<Item>}
   * @public
   */
  public async show(
    id: string | number,
    {
      params,
      headers,
    }: {
      params?: RequestParams;
      headers?: RequestHeaders;
    } = {},
  ): Promise<Item> {
    return this.request<Item, ItemResponse<Item>>({
      method: 'get',
      url: id.toString(),
      params,
      headers,
    }).then((response) => {
      return response.data;
    });
  }
}
